import React from 'react';
import { useEffect } from 'react';

function useAutoScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
}

export default function Container(props: React.PropsWithChildren) {
  useAutoScrollToTop();

  return <div className="container mx-auto p-8 max-w-2xl">{props.children}</div>;
}
